/**
 * Tracking events are documented in docs/tracking/meta.md (see docs/tracking/README.md).
 * If you add, remove or change when an event is sent, update that doc in the same PR
 * and let the Acquisition and Data teams know.
 */
export enum CapiServerEventName {
  PAGEVIEW = "PageView",
  TEST_EVENT = "TestEvent",
  INITIATE_CHECKOUT = "InitiateCheckout",
  ADD_TO_CART = "AddToCart",
  PURCHASE = "Purchase",
  LEAD = "Lead",
  START_TRIAL = "StartTrial",
  QUIZ_STARTING = "QuizStarting",
  REACTIVATION = "Reactivation",
}
